// Patches fields of the cached /users/me data. Used as a state updater, so each async
// response patches the latest state instead of restoring its own older snapshot of the user.
export const mergeUserData = (userStore, patch) => ({
  ...userStore,
  data: { ...userStore.data, ...patch },
});
